import './studio.css';
import Studio from './Studio.svelte';

import * as Sentry from "@sentry/svelte";

Sentry.init({
  dsn: "https://c93e186f00170431bb1bc6d6d0f04c40@o4504492294995968.ingest.us.sentry.io/4508687705440256",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({
        levels: ['error'],
    })
  ],
  tracesSampleRate: 1.0,
});

const studio = new Studio({
  target: document.getElementById('studio'),
})

export default studio
